import styled from 'styled-components';

export const ChangelogModalStyled = styled.div`
  display: flex;
  
  .changelogModal {
    &__table {
      border-collapse: collapse;
      table-layout: fixed;
      width: 100%;

      &Th {
        text-align: center;
        padding: 8px;
        font-size: ${props => props.theme.fontSizeS};
        font-family: ${props => props.theme.fontBold};
        color: white;
        background-color: ${props => props.theme.uiColors.changelogHeader};

        &:nth-child(1) {
          width: 130px;
        }
        &:nth-child(2) {
          width: 160px;
        }
      }
      
      &Td {
        font-family: ${props => props.theme.fontRegular};
        border: 1px solid ${props => props.theme.uiColors.changelogTdBorder};
        text-align: left;
        padding: 8px;
        font-size: ${props => props.theme.fontSizeXS};
        color: ${props => props.theme.uiColors.changelogTdBg};
        overflow-wrap: anywhere;
        vertical-align: top;
      }

      &Tr:nth-child(even) {
        background-color: ${props => props.theme.uiColors.changelogTr};
      }
      
      &Item {
        &Title {
          color: ${props => props.theme.uiColors.changelogTitle};
          font-family: ${props => props.theme.fontSemiBold};
          font-size: ${props => props.theme.fontSizeXS};
        }
        &Val {
          border-width: 1px 0 1px 5px;
          border-color: ${props => props.theme.uiColors.changelogValBorder};
          border-left-color: ${props => props.theme.uiColors.changelogOther};
          border-style: solid;
          margin-top: -1px;
          padding-left: 5px;

          &--editDot{
            border-left-color: ${props => props.theme.uiColors.changelogEdit};
          }
          &--deleteDot{
            border-left-color: ${props => props.theme.uiColors.changelogDelete};
          }
          &--addDot{
            border-left-color: ${props => props.theme.uiColors.changelogAdd};
          }
          &--otherDot{
            border-left-color: ${props => props.theme.uiColors.changelogOther};
          }
        }
      }
    }
    
    &__details {
      display: inline-block;
      max-width: 100%;
      vertical-align: top;

      summary {
        cursor: pointer;
        text-decoration: underline;
      }

      pre {
        max-height: 200px;
        margin: 4px 0;
        overflow: auto;
        white-space: pre-wrap;
      }
    }

    &__emptyText {
      width: 100%;
      color: ${props => props.theme.uiColors.changelogEmpty};
      text-align: center;
    }
    
    &__skeleton {
      width: 100%;
    }
  }
`;
